import { useState } from 'react';
import { LayoutModule } from '../../../../layout/modules';
import { Box } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import QuizIcon from '@mui/icons-material/Quiz';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { SURVEYS_RESPONSES } from '../../../../../routes/paths';
import { useSurveyResponseDetail } from './hook';
import { SurveyResponseData } from './data';
import { SurveyResponseAnswers } from './answers';
import { SurveyResponseLogs } from '../logs';
import { asyncGetSurveyResponseLogs } from '../../../../../services/survey.service';

export const SurveyResponseDetail = () => {
    const { response, loading } = useSurveyResponseDetail();
    const [showHistorical, setShowHistorical] = useState(false);
    const [historical, setHistorical] = useState<any[]>([]);

    const toggleHistorical = async () => {
        if (!showHistorical && response?.id && historical.length === 0) {
            // Cargar logs solo la primera vez
            const data = await asyncGetSurveyResponseLogs(response.id);
            setHistorical(data);
        }
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle de Respuesta"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={response?.id || ''}
                        buttonSearch={{
                            show: true,
                            route: SURVEYS_RESPONSES,
                        }}
                        buttonLog={{
                            show: Boolean(response?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && response?.id && (
                    <Box sx={{ marginBottom: 3 }}>
                        <SurveyResponseLogs
                            historical={historical}
                            showHistorical={true}
                        />
                    </Box>
                )}

                <LayoutModule
                    title="Información General"
                    showTitle={false}
                    titleChildren="Información de la respuesta"
                    icon={<AssignmentIcon sx={{ color: 'primary.main' }} />}
                >
                    <SurveyResponseData response={response} loading={loading} />
                </LayoutModule>

                <Box sx={{ mt: 3 }}>
                    <LayoutModule
                        title="Respuestas"
                        showTitle={false}
                        titleChildren="Respuestas de la encuesta"
                        icon={<QuizIcon sx={{ color: 'primary.main' }} />}
                    >
                        <SurveyResponseAnswers
                            response={response}
                            loading={loading}
                        />
                    </LayoutModule>
                </Box>
            </LayoutModule>
        </>
    );
};
